import React, { Component } from "react";
import { connect } from "react-redux";
import LandingPage from "./js/Components/LandingPage/LandingPage.jsx";
import HomeRouter from "./js/Components/Home/HomeRouter";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import AuthorizedRoute from "./js/Components/AuthorizedRoute.jsx";
import * as Actions from "./js/Actions/Actions";
import PrivacyPolicy from "./js/Components/PrivacyPolicy.jsx";
import TermsOfUse from "./js/Components/TermsOfUse.jsx";
// import ReactGA from "react-ga";
import { DragDropContext } from "react-beautiful-dnd";
import * as DragActions from "./js/Actions/TempPlaylistActions.js";
// ReactGA.initialize("UA-113242156-3", {
//   allowLinker: true
// });

import TagManager from 'react-gtm-module'
 
const tagManagerArgs = {
    gtmId: 'GTM-5FWTTRP'
}
TagManager.initialize(tagManagerArgs);

class App extends Component {
  componentWillMount() {
    const { dispatch, user, history } = this.props;
    if (user) {
      dispatch(Actions.getUser(user.token, history));
    }
  }

  dragEnd = result => {
    this.props.dispatch(DragActions.DragEnd(result));
  };
  dragStart = () => {
    this.props.dispatch(DragActions.DragStart());
  };

  render() {
    return (
      <DragDropContext onDragStart={this.dragStart} onDragEnd={this.dragEnd}>
        <script src="https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1"></script>
        <div>
          <Switch>
            <AuthorizedRoute path="/Home" component={HomeRouter} />
            <Route path="/privacy" component={PrivacyPolicy} />
            <Route path="/termsofuse" component={TermsOfUse} />
            <Route path="/welcome" component={LandingPage} />
            <Redirect to="/Home" />
          </Switch>
        </div>
      </DragDropContext>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.mainState.user
  };
};

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js